import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "CL_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#CL_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0h14v14H0V0z", fill: "#3D58DB" }), /* @__PURE__ */ e.createElement("path", { d: "M14-2h18v16H14V-2z", fill: "#F7FCFF" }), /* @__PURE__ */ e.createElement("path", { d: "M0 14h32v10H0V14z", fill: "#E31D1C" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.014 9.784l-3.803 2.271L5.088 8.19 1.764 5.68 5.6 5.64 7.05 2.211l.932 3.427 3.632.017-2.762 2.455 1.434 3.944-3.27-2.271z",
      fill: "#F7FCFF"
    }
  ))
);
export {
  t as default
};
